/**
 * @param {string} type video type to load
 */
function loadVideo(type) {
  const video = document.getElementById(`video-${type}`);
  const videoData = document.querySelector(`[data-video-${type}]`);
  const sources = videoData.querySelectorAll('source');
  sources.forEach((source) => {
    if (video.querySelectorAll('source').length < sources.length) {
      video.appendChild(source);
    }
  });
  if (type === 'desktop') {
    if (video.readyState !== 4) video.load();
  }
  if (video.paused) video.play();
}

/**
 *
 */
window.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 480) {
    loadVideo('desktop');
  } else {
    loadVideo('mobile');
  }
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 480) {
    loadVideo('desktop');
  } else {
    loadVideo('mobile');
  }
});
